import { render, staticRenderFns } from "./request-and-load.vue?vue&type=template&id=641b1ccc"
import script from "./request-and-load.vue?vue&type=script&lang=js"
export * from "./request-and-load.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports